export default __webpack_public_path__ + "static/media/rudolph.85e445e6.png";